
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  --element-margin-botttom:var(--spacing-6);

  --link-margin-x:-0.1875rem;
  --link-padding-x:0.1875rem;

  --list-y-spacing:var(--spacing-3);
  --list-x-spacing:var(--spacing-12);
  --list-marker-color:var(--brand-gray-900);

  --heading-color:var(--brand-primary-dark-blue);
  --body-color-default:var(--brand-gray-900);

  font-family:var(--ff-body);
  font-weight:var(--fw-normal);
  font-weight:var(--body-font-weight, var(--fw-normal));
  font-size:var(--body-font-size);
  line-height:var(--lh-percentage-body);
  line-height:var(--body-line-height, var(--lh-percentage-body));
}

h2::after{
  content:'';
  border-radius:8px;
  border-radius:var(--ruled-border-radius, 8px);
  border:solid var(--brand-green-900);
  border-width:8px 0 0;
  border-width:var(--ruled-border-width, 8px) 0 0;
  display:block;
  height:0.0625rem;
  margin:1rem 0;
  max-width:5.3125rem;
  max-width:var(--ruled-max-width, 5.3125rem);
  padding:0;
  position:relative;
  text-align:left;
  width:100%;
}

strong{
  font-family:var(--ff-bold);
}

h1 strong,
h2 strong,
h3 strong,
h4 strong,
h5 strong,
h6 strong{
  font-family:inherit;
}

p strong{
  font-family:inherit;
}

outline-styled-text-baseline p,
p,
a,
ul,
ol{
  font-weight:var(--body-font-weight);
  font-size:var(--body-font-size);
  line-height:var(--body-line-height);
}

outline-styled-text-baseline p,
p{
  display:block;
  margin-bottom:var(--element-margin-botttom);
  color:var(--body-color-default);
  color:var(--body-color, var(--body-color-default));
  margin-top:0 !important;
}

p:last-child{
  margin-bottom:0;
}

ol,
ul{
  counter-reset:ol-counter;
  list-style-position:outside;
}

ol{
  padding-left:var(--spacing-12);
}

ul{
  padding-left:var(--spacing-16);
}

ol{
  list-style-type:decimal;
}

ul ul,
ol ol{
  margin-top:var(--list-y-spacing);
}

ul li{
  position:relative;
  margin-bottom:var(--list-y-spacing);
  list-style-type:none;
}

ul li::before{
    color:var(--list-marker-color);
    content:'•';
    padding-right:var(--spacing-2);
    margin-left:-16px;
    display:inline;
  }

@media (min-width: 1024px){

ul li::before{
      margin-left:-20px
  }
    }

ul li .ck-list-bogus-paragraph,
  ul li span{
    display:initial !important;
  }

ol li{
  position:relative;
}

> ul,
> ol{
  margin-bottom:var(--element-margin-botttom);
}

ol > li{
  position:relative;
  margin-bottom:var(--list-y-spacing);
  counter-increment:ol-counter;
  margin-left:var(--spacing-5);
}

ul li *,
ol li *{
  text-indent:initial;
}

li li{
  margin-left:0;
}

li ul,
li ol{
  margin-left:var(--list-x-spacing);
}

ul ol li{
  margin-left:var(--list-x-spacing);
}

ul ul,
ol ol{
  padding-left:0;
}

ol ol li{
  margin-left:var(--spacing-2);
}

ol > li::marker{
  color:var(--list-marker-color);
  font-family:var(--ff-display);
}

@media (min-width: 768px){
  .align-left,
  .align-right{
    max-width:50%;
  }

  .align-right{
    float:right;
    margin-left:var(--spacing-6);
    margin-bottom:var(--element-margin-botttom);
  }

  .align-left{
    float:left;
    margin-right:var(--spacing-6);
    margin-bottom:var(--element-margin-botttom);
  }
}

figure{
  display:table !important;
}

figcaption{
  display:table-caption;
  caption-side:bottom;
  color:var(--brand-white);
  background-color:var(--brand-primary-dark-blue);
  font-style:italic;
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
  padding:var(--spacing-3);
}

blockquote{
  margin-bottom:var(--element-margin-botttom);
  max-width:80%;
  min-height:4.5rem;
  margin-left:auto;
  margin-right:auto;
  border-left:0 !important;
}

hr{
  display:block;
  width:100%;
  height:4px;
  height:var(--ruled-border-width, 4px);
  max-width:75px;
  max-width:var(--ruled-max-width, 75px);
  border-radius:8px;
  border-radius:var(--ruled-border-radius, 8px);
  background:var(--brand-green-900);
  text-align:left;
  margin-bottom:var(--element-margin-botttom);
  border:0;
}

.text-body-sm,
.text-body-sm a{
  --body-font-size:var(--fs-body-sm);
  --body-line-height:1.5;
  --link-font-size:var(--fs-body-sm);
  --link-line-height:1.5;
}

.text-body-md,
.text-body-md a{
  --body-font-size:var(--fs-body-md);
  --body-line-height:1.5;
  --link-font-size:var(--fs-body-md);
  --link-line-height:1.5;
}

.text-body-lg,
.text-body-lg a{
  --body-font-size:var(--fs-body-lg);
  --body-line-height:1.5;
  --link-font-size:var(--fs-body-lg);
  --link-line-height:1.5;
}
`;